import { render, staticRenderFns } from "./trafficXibo.vue?vue&type=template&id=58661072&scoped=true&"
import script from "./trafficXibo.vue?vue&type=script&lang=js&"
export * from "./trafficXibo.vue?vue&type=script&lang=js&"
import style0 from "./trafficXibo.vue?vue&type=style&index=0&id=58661072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58661072",
  null
  
)

export default component.exports